<template>
    <BreadCrumb PageTitle="Modifier un marchand" />
    <EditMarchand />
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../../components/Common/BreadCrumb.vue";
    import EditMarchand from "../../../components/Ecommerce/Marchand/EditMarchand.vue";
  
    export default defineComponent({
      name: "EditMarchandPage",
      components: {
        BreadCrumb,
        EditMarchand,
      },
    });
  </script>